import { useRef } from "react";
import { Link } from "react-router-dom";
import { useGsapDownStagger, useGsapUpward } from "../Hooks/gsap";
import logoImage from "../img/white.png"
const Navbar = () => {
  const li1 = useRef(null);
  const li2 = useRef(null);
  const li3 = useRef(null);
  const fav = useRef(null);
  const logo = useRef(null);

  const liArr = [li1, li2, li3];
  const favArr = [fav];

  useGsapDownStagger(liArr, 1.5);
  useGsapDownStagger(favArr, 2.6);
  useGsapUpward(logo, 2.2);

  return (
    <div className="navbar wrapper">
      <ul className="links">
        <li ref={li1}>
          <Link to="featured">Featured</Link>
        </li>
        <li ref={li2}>
          <Link to="about">About</Link>
        </li>
        <li ref={li3}>
          <Link to="gallery">Gallery</Link>
        </li>
      </ul>
      <div className="logo" ref={logo}>
        <Link to="/">
        <img src={logoImage} alt="Footer Logo" className="h-40" />
        </Link>
      </div>
      <div className="favourite-link" ref={fav}>
        <Link to="contactus">Contact Us</Link>
      </div>
    </div>
  );
};

export default Navbar;
